import {
  addDays,
  addMinutes,
  addSeconds,
  differenceInDays,
  differenceInSeconds,
  differenceInMilliseconds as diffInMs,
} from "date-fns"

import { IDateCalculator } from "../interfaces"

const SECONDS_IN_DAY = 86400
const SECONDS_IN_WEEK = 7 * SECONDS_IN_DAY

export default class DateFnsCalculator extends IDateCalculator {
  addDays(date: number | Date, days: number) {
    return addDays(date, days)
  }

  addSeconds(date: number | Date, seconds: number) {
    return addSeconds(date, seconds)
  }

  addMinutes(date: number | Date, minutes: number) {
    return addMinutes(date, minutes)
  }

  addMinutesSeconds(date: number | Date, seconds: number) {
    return addSeconds(date, seconds)
  }

  differenceInDays(date1: number | Date, date2: number | Date) {
    return differenceInDays(date1, date2)
  }

  differenceInSeconds(date1: number | Date, date2: number | Date) {
    return differenceInSeconds(date1, date2)
  }

  differenceInMilliseconds(date1: number | Date, date2: number | Date) {
    return diffInMs(date1, date2)
  }

  secondsUntilNextEpoch(date = new Date()) {
    // console.log("secondsUntilNextEpoch->date", date)
    // console.log("date.getTime()", date.getTime())
    // console.log("date.getTime() floor", Math.floor(date.getTime() / 1000))

    return SECONDS_IN_WEEK - (Math.floor(date.getTime() / 1000) % SECONDS_IN_WEEK)
  }

  currentEpochNumber({ date, chainSlug }: { date?: Date; chainSlug: string }) {
    const dateNow = date ?? new Date()
    if (chainSlug === "fantom") {
      return Math.floor(dateNow.getTime() / (86400000 * 7)) - 2758
    } else if (chainSlug === "base") {
      return Math.floor(dateNow.getTime() / (86400000 * 7)) - 2804
    } else if (chainSlug === "sonic") {
      return Math.floor(dateNow.getTime() / (86400000 * 7)) - 2866
    }

    return 0
  }
}
